AccessController = App.loadClass 'admin::Angular/AccessController'

class exports.SppAnalysisController extends AccessController
    constructor: (@scope, @transitions, @data, @window, @http) ->
        super('spp_analysis', @http)

        @scope.title = 'SPP Analysis'
        @scope.fullpage = true
        @scope.absolute_errors = true
        @scope.excelUrl = 'backend/admin/spp-analysis/do-the-math'

        # Instance data
        @scope.companies = []
        @scope.programs = []
        @scope.dates = []
        @scope.companies_array = []
        @scope.enableProgram = false
        @scope.showSurveys = false
        @scope.is_developer = false
        @scope.is_account_services = false
        @scope.submit = false
        @scope.role_needs_set = true
        @scope.selected = {}
        @scope.selected.program = null
        @scope.selected.company = null
        @scope.selected.user = null
        @scope.selected.rep = null
        @scope.style = ''
        @scope.program_options = []
        @scope.users = []
        @scope.users_reps = []
        @scope.reps = []
        @scope.surveys = []
        @scope.disabled = false
        @scope.loading = false

        # Scope functions
        @scope.enablePrograms = @enablePrograms
        @scope.fetchProgramsUsers = @fetchProgramsUsers
        @scope.fetchRepsForUsers = @fetchRepsForUsers
        @scope.getProgramForUser = @getProgramForUser
        @scope.doTheMath = @doTheMath
        @scope.launchExcelReport = @launchExcelReport
        @scope.setRole = @setRole
        @scope.clearTree = @clearTree
        @scope.fetchDeveloperData = @fetchDeveloperData
        @scope.loadDevSurveyData = @loadDevSurveyData

    enablePrograms: () =>
        # Grab data we need off of companies object and populate placement_program select box with it
        @scope.program_options = []

        if @scope.selected.company
            for company in @scope.companies
                if company.id is @scope.selected.company
                    for program in company.programs
                        @scope.program_options.push [program.id, program.display_name]

        @scope.program_options.sort (a, b) ->
            a = a[1].toLowerCase()
            b = b[1].toLowerCase()

            return 1 if (a > b)
            return -1 if (a < b)
            return 0


    fetchProgramsUsers: (program, company) =>
        @scope.users = []
        @scope.loading = true
        @data.fetchProgramsUsers(program, company).then (response) =>
            res = response.data
            if res.status.type is 'success'
                # sort users
                @scope.users = res.data.users
                @scope.users_reps = res.data.reps
                @scope.loading = false

    fetchRepsForUsers: (user) =>
        @scope.reps = @scope.users_reps[user.username]
        @scope.reps.sort()

    getProgramForUser: (user) =>
        if @scope.surveys.length > 0
            @scope.surveys = []

        if user?
            if @scope.selected.rep
                @loadSurveyData(user.id, @scope.selected.rep)
            else
                @loadSurveyData(user.id, @scope.reps)

    loadSurveyData: (user, rep, fsr_id = null) =>
        @data.getProgramForUser(user, rep, @scope.selected.program, fsr_id).then (response) =>
            res = response.data
            if res.status.type is 'success'
                @scope.finished_surveys = res.data
                @sortSurveys()
                angular.element(@window).trigger 'resize'

    loadDevSurveyData: (fsr_id) =>
        @loadSurveyData(null, null, fsr_id)

    sortSurveys: () =>
        for survey in @scope.finished_surveys
            for k, v of survey
                if k is 'display_name'
                    @scope.surveys.push v
                    break

        # sort surveys by date
        @scope.surveys.sort (a, b) ->
            # the number 19 will always be how many characters (from the right)
            # that represent the date portion of the survey display name.
            return new Date(b.substr(-19)) - new Date(a.substr(-19))

        if @scope.surveys.length is 0
            @scope.showSurveys = true
        else
            @scope.showSurveys = true

    doTheMath: (index) =>
        @launchExcelReport(index)

    launchExcelReport: (id) =>
        url = @scope.excelUrl + '?' + $.param {
            survey: @findSurveyById(id),
            program: @scope.selected.program
        }
        win = @window.open(url, '_blank')
        return true

    findSurveyById: (id) =>
        for survey in @scope.finished_surveys when survey.id is id
            return survey

    setRole: (dev) =>
        company = @scope.selected.company
        program = @scope.selected.program
        user = @scope.selected.user

        if dev
            @scope.is_developer = true
            @scope.is_account_services = false
            @scope.fetchDeveloperData()
            if program?
                @fetchDeveloperData(program)
        else
            @scope.is_account_services = true
            @scope.is_developer = false
            @loadScopeData(@data.getCompanies(), 'companies').then (result) =>
                if company?
                    @enablePrograms()

                    if program?
                        @clearTree 'program'
                        @fetchProgramsUsers(@scope.selected.program, @scope.selected.company)
                        @getProgramForUser(@scope.selected.user)

            if user? and program? and company?
                @getProgramForUser(user)

        # @scope.dumb = true

    clearTree: (level = null) =>
        if level is 'company'
            @scope.selected.program = null
            @scope.selected.user = null
            @scope.selected.rep = null
            @scope.program_options = []
            @scope.users = []
            @scope.reps = []
        else if level is 'program'
            @scope.selected.user = null
            @scope.selected.rep = null
            @scope.users = []
            @scope.reps = []
        else if level is 'user'
            @scope.selected.rep = null
            @scope.reps = []

        @scope.surveys = []
        @scope.showSurveys = false

    fetchDeveloperData: (pp_id = null) =>
        @scope.loading = true
        @data.fetchDeveloperData(pp_id).then (response) =>
            res = response.data
            if res.status.type is 'success'
                if res.data.pp
                    @scope.pp_ids = res.data.pp

                if res.data.fsr
                    @scope.fsr_ids = res.data.fsr

                if res.data.companies_id
                    @scope.selected.company = res.data.companies_id

            @scope.loading = false

                # change blade to send both onchange here as well as make pp_id top choice.
